import * as React from 'react';
export const azloSvg = React.forwardRef(function azloSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 0h32v32H0z',
        fill: '#4f64ff',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M20.042 15.81v4.232h-4.233zm-8.085-3.852h4.233l-4.233 4.233zm0-5.107H25.15V25.15h-4.256V13.753l-7.14 7.14h6.289v4.256H6.852V6.85h4.254v11.396l7.14-7.14h-6.289zM6 26h20V6H6z',
        fill: '#fff',
        fillRule: 'nonzero',
      }),
    ),
  );
});
azloSvg.defaultProps = {
  height: '32',
  viewBox: '0 0 32 32',
  width: '32',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var azlo = {
  category: 'brand',
  colorable: false,
  name: 'azlo',
  svg: azloSvg,
};
